import React from 'react';
import { Controller, type FieldErrorsImpl, DeepRequired, Control } from 'react-hook-form';
import { Grid, InputLabel, FormHelperText } from '@mui/material';

import { InputChip } from 'components/InputChip';

import { CauseFieldName, CauseField, PresenceFormData } from './types';

interface CausesControlledInputProps {
  control: Control<PresenceFormData, any>;
  errors: FieldErrorsImpl<DeepRequired<PresenceFormData>>;
  isSubmitted: boolean;
  cause: CauseField<CauseFieldName>;
}

export const CausesControlledInput = ({
  cause,
  control,
  errors,
  isSubmitted,
}: CausesControlledInputProps) => {
  const {
    name,
    maxItems,
    required = false,
    label,
    title,
    items,
    values = [],
    append,
    replace,
  } = cause;
  return (
    <div>
      <InputLabel
        sx={{
          // TODO @EV: fix this to adjust to right size
          fontSize: '0.75rem',
          paddingBottom: '0.5rem',
        }}
      >{`${title}${required ? ' *' : ''}`}</InputLabel>
      <Grid key={`${name}-grid`} item xs={12}>
        {items.toArray().map((item) => (
          <Controller
            key={item.id}
            name={name}
            control={control}
            render={() => (
              <InputChip
                onClick={() => {
                  if (values.length < maxItems + 1) {
                    append({ id: item.id });
                  }
                }}
                label={item.name}
                selected={values.some((value) => value.id === item.id)}
                error={
                  (isSubmitted && !values.length) ||
                  values.findIndex((value) => value.id === item.id) === maxItems
                }
                handleDelete={() => {
                  replace(values.filter((value) => value.id !== item.id));
                }}
                variant="outlined"
                style={{ margin: 4 }}
              />
            )}
          />
        ))}
        {errors && errors[name]?.root?.message && (
          <FormHelperText error={Boolean(errors[name]?.root?.message)}>
            {errors[name]?.root?.message || `You can select up to ${maxItems} ${label}`}
          </FormHelperText>
        )}
      </Grid>
    </div>
  );
};
